import axios from "axios";
import Cookies from "js-cookie";
import { api } from "config";
// import { t } from "i18next";
import { toast } from "react-toastify";

// export const baseURL = 'http://127.0.0.1:5001/coded-plus/us-central1';
// export const baseURL = 'https://us-central1-coded-plus.cloudfunctions.net';

const hostname = window.location.hostname;
const rootDomain = `.${hostname.split('.').slice(-2).join('.')}`;

// Create instance
const axiosInstance = axios.create({
  baseURL: api.API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

const setHeaders = (config) => {
  const token = Cookies.get('authorization') ?  Cookies.get('authorization') : null;
  
  config.headers["authorization"] = token;
  config.headers["environment"] = api.ENVIRONMENT || "Dev";
  config.headers["langid"] = localStorage.getItem("langId") || 1;
  config.headers["refreshtoken"] = config.url?.includes("/SaveLoginSession")
    ? Cookies.get("customToken") : null;

  return config;
};

   
axiosInstance.interceptors.request.use(setHeaders);

let isRefreshing = false;
let failedQueue = [];
 
const processQueue = (error, token = null) => {
  failedQueue.forEach(prom => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });
 
  failedQueue = [];
};

// Response interceptor
axiosInstance.interceptors.response.use(
  response => (response.data ? response.data : response),
  async error => {
    const originalRequest = error.config;
    const status = error?.response?.status;


    if (status === 401 && !originalRequest._retry) {
      if (isRefreshing) {
        return new Promise(function (resolve, reject) {
          failedQueue.push({ resolve, reject });
        })
          .then(token => {
            originalRequest.headers['authorization'] = token;
            return axios(originalRequest);
          })
          .catch(err => Promise.reject(err));
      }

      originalRequest._retry = true;
      isRefreshing = true;

      try {
        // Call your refresh token API here
        const refreshResponse = await axiosInstance.post('/SaveLoginSession');

        const data = refreshResponse.data;
        Cookies.set("authorization", data.authToken, {
          expires: 30,
          path: "/",
          secure: true,
          sameSite: "None",
          domain: rootDomain
        });
        Cookies.set("customToken", data.refreshToken, {
          expires: 30,
          path: "/",
          secure: true,
          sameSite: "None",
          domain: rootDomain
        });
        axios.defaults.headers.common['authorization'] = data.authToken;
        // processQueue(null, data.authToken);
        // originalRequest.headers['authorization'] = data.authToken;
        setTimeout(() => {
          window.location.reload();
        }, 100)
      } catch (refreshError) {
        console.log("refreshError", refreshError);
        
        processQueue(refreshError, null);
        Cookies.remove("authorization");
        Cookies.remove("customToken");
        window.location.href = '/login';
        return Promise.reject(refreshError);
      } finally {
        isRefreshing = false;
      }
    // } else if (error?.response?.status === 404 && error?.response?.data?.message === "User not found") {
    //   toast.error(translation?.Common?.UserNotFound);
    //   Object.keys(Cookies.get()).forEach((cookieName) => {
    //     Cookies.remove(cookieName);
    //   });
    //   window.location.href = "/login";
    // } else if (error?.response?.status === 404 && error?.response?.data?.message === "Please contact to support team") {
    //   toast.error(translation?.Common?.PleaseContactToSupportTeam);
    //   Object.keys(Cookies.get()).forEach((cookieName) => {
    //     Cookies.remove(cookieName);
    //   });
    //   window.location.href = "/login";
    }

    const messageMap = {
      400: 'Invalid credentials',
      // 401: 'Invalid credentials',
      404: 'Sorry! the data you are looking for could not be found',
      500: 'Internal Server Error',
    };
    
    const message = error?.response?.data?.message || messageMap[status] || error?.message || "Something went wrong";
    console.log('error: ', error);
    console.log('message: ', message);
    return Promise.reject(message)
  }
);


export default axiosInstance;